module.exports = __webpack_public_path__ + "img/after-sale.1604f56b.jpg";